var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "spinner-border text-secondary",
      class: _vm.classSize,
      attrs: { role: "status" },
    },
    [
      _c("span", { staticClass: "sr-only" }, [
        _vm._v(_vm._s(_vm.$t("global.loading"))),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }